import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// local testing

// import { connectFunctionsEmulator } from 'firebase/functions';
// import { connectFirestoreEmulator } from 'firebase/firestore';
// import { connectAuthEmulator } from 'firebase/auth';
// import { functions, db, auth } from './firebase/config';

// if (window.location.hostname === 'localhost') {
//   connectFunctionsEmulator(functions, '127.0.0.1', 5001);
//   connectFirestoreEmulator(db, '127.0.0.1', 8081);
//   connectAuthEmulator(auth, 'http://127.0.0.1:9099');
// }

// end of local testing

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
reportWebVitals();